import { clear, get, set } from 'idb-keyval';

export const kv = {
  set,
  get,
  clear,
};
